import Tray, { TrayProps } from '@components/containers/tray';
import styled from '@emotion/styled';
import { OutboundLinkContext } from '@enums';
import { AdditionalProductFragment } from '@graphql/generated/graphql';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';
import { HStack, VStack } from '@lib/uikit';

import { AdditionalProductActions } from './AdditionalProductActions';

const SStrapiImage = styled(StrapiImage)`
    min-height: 45dvh;
    max-height: 60dvh;
    aspect-ratio: 1/1;
    width: 100%;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.shape.radius.default};
`;

const Title = styled.p`
    font: ${({ theme }) => theme.typography.heading3};
`;

const Description = styled.p`
    font: ${({ theme }) => theme.typography.subtitle6};
    font-weight: lighter;
`;

const Price = styled(Title)`
    flex-shrink: 0;
    font-weight: 500;
`;

const Footer = styled.div`
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    padding-block: ${({ theme }) => theme.spacing.xxs};
    background-color: ${({ theme }) => theme.palette.background.paper};
    box-shadow: 0 -16px 16px 0 ${({ theme }) => theme.palette.background.paper};
`;

interface Props extends TrayProps {
    additionalProduct: AdditionalProductFragment;
    context: OutboundLinkContext;
}

export const AdditionalProductDetailTray = ({
    additionalProduct,
    context,
    ...trayProps
}: Props) => {
    if (!additionalProduct.Url) return null;

    return (
        <Tray {...trayProps}>
            <VStack spacing='sm'>
                <SStrapiImage
                    sizes='(max-width: 748px) 100vw, 33vw'
                    src={getStrapiAssetUrl(additionalProduct.Image)}
                    formats={additionalProduct.Image?.formats}
                    alt={
                        additionalProduct.Image?.alternativeText ??
                        additionalProduct.Name
                    }
                />

                <VStack spacing='xxs'>
                    <HStack alignItems='start' justifyContent='space-between'>
                        <Title>{additionalProduct.Name}</Title>
                        {additionalProduct.Price && (
                            <Price>{additionalProduct.Price}</Price>
                        )}
                    </HStack>
                    {additionalProduct.Description && (
                        <Description>
                            {additionalProduct.Description}
                        </Description>
                    )}
                </VStack>
                <Footer>
                    <AdditionalProductActions
                        additionalProduct={additionalProduct}
                        context={context}
                    />
                </Footer>
            </VStack>
        </Tray>
    );
};
